module.exports = __webpack_public_path__ + "img/btn_menu_zyz_c.c52b3338.png";